//import { Auth } from "aws-amplify";
import Http from './Http';
import { unsafeEncrypt } from './Encrpyt';
import { Keys, subscribe, publish } from './MessageBus';
import moment from 'moment-timezone';
import qs from 'qs';
import { processDates } from './ItemsStore';
import Config from './Config';

const LOCALSTORAGE_AUTH_KEY = 'kw.auth';

// Renew the session 5 minutes of the way before it expires
const RENEW_TIME = 5 * 60 * 1000;

let userDetails = null;

moment.tz.setDefault('UTC');

subscribe(Keys.HTTP_UNAUTHORIZED_REQUEST, function (response) {
    //console.log('Un-authorized ', response);
    UserManager.resetSession();
});

setInterval(function renewSession() {
    UserManager.updateMyDetails()
}, 60 * 1000 * 5);

setTimeout(() => {
    UserManager.getUserDetails()
}, 0)

export function normalizeUser(user) {
    const getFirstCharacter = (s) => s && s.length > 0 ? s[0] : '';
    user.name = `${user.firstName} ${user.lastName}`.trim();
    user.fullName = user.middleName ? `${user.firstName} ${user.middleName} ${user.lastName}` : `${user.firstName} ${user.lastName}`.trim();
    user.initials = `${getFirstCharacter(user.firstName)}${getFirstCharacter(user.lastName)}`.trim();
    return user;
}

// https://stackoverflow.com/a/38445519/1877617
function redirectFormPost(url, data) {
    var form = document.createElement('form');
    document.body.appendChild(form);
    form.method = 'post';
    form.action = url;
    for (var name in data) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.value = data[name];
        form.appendChild(input);
    }
    form.submit();
}


export default class UserManager {
    static sessionAuthDetails() {
        try {
            return JSON.parse(localStorage.getItem(LOCALSTORAGE_AUTH_KEY));
        } catch (err) { }
        return null;
    }

    static isAuthenticated() {
        /* try {
             const auth = this.sessionAuthDetails();
             return auth && auth['expires'] >= Date.now();
         } catch (err) { }
         return false;*/
        return userDetails != null;
    }

    static getAuthToken() {
        try {
            const auth = this.sessionAuthDetails();
            return auth['authToken'];
        } catch (err) { }
        return null;
    }

    static async renewSession() {
        return new Promise((resolve, reject) => {
            if (this.isAuthenticated()) {
                Http.post('/api/users/renew-session')
                    .then((response) => {
                        processDates(response.data)
                        const expiryTime = response.data.expiryTime;
                        const auth = this.sessionAuthDetails();
                        auth.expires = expiryTime;
                        localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(auth));
                        resolve('Session renewed');
                    })
                    .catch((err) => {
                        reject(err);
                    });
            } else {
                resolve('Session renewed');
            }
        });
    }

    static async getUserDetails() {
        if (userDetails) {
            return new Promise((resolve, reject) => {
                resolve(userDetails);
            });
        }
        return this.updateMyDetails();
    }

    static getUserDetailsSync() {
        return userDetails;
    }

    static async updateMyDetails() {
        return new Promise((resolve, reject) => {
            Http.get('/auth/me')
                .then((response) => {
                    const data = normalizeUser(processDates(response.data));
                    userDetails = data;
                    resolve(userDetails);
                    publish('USER_DETAILS_UPDATED', { ...userDetails });
                    moment.tz.setDefault(userDetails.settings.timezone);
                    return data;
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static async authenticateStep1_v2(email, password) {
        return new Promise((resolve, reject) => {
            const data = qs.stringify({
                emailAddress: email.trim(),
                password: password
            });
            const options = {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            };

            // Spring Security is setup to return HTTP 200 when successful.
            // On failure, returns a 302 with redirect which can be ignored.
            Http.post('/auth/step1_hyperold', data, options)
                .then((response) => {
                    const data = processDates(response.data);
                    resolve(data);
                })
                .catch((err) => {
                    try {
                        if (err.response.status == 403) { // forbidden
                            Http.post('/auth/step1_hyperold', data, options)
                                .then((response) => {
                                    const data = processDates(response.data);
                                    resolve(data);
                                })
                                .catch((err) => {
                                    reject(err.response.data.error);
                                })
                        } else {
                            reject(err.response.data.error);
                        }
                    } catch (e2) {
                        reject((err || '').toString());
                    }
                });
        });
    }

    static async authenticateStep1(email, password) {
        return new Promise((resolve, reject) => {
            Http.post('/api/users/authenticate/step-1', {
                email: unsafeEncrypt(email.trim()),
                password: unsafeEncrypt(password.trim()),
            })
                .then((response) => {
                    const data = processDates(response.data);
                    resolve(data);
                })
                .catch((err) => {
                    try {
                        reject(err.response.data.error);
                    } catch (e2) {
                        reject((err || '').toString());
                    }
                });
        });
    }

    static async authenticate(email, password, mfaToken) {

        const data = qs.stringify({
            username: `${mfaToken}:${email}`,
            password: password
        });
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return new Promise((resolve, reject) => {
            Http.post('/login', data, options)
                .then((response) => {
                    Http.get('/auth/me').then(response => {
                        const data = normalizeUser(processDates(response.data));
                        //localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(data.auth));
                        userDetails = data;
                        publish('USER_DETAILS_UPDATED', { ...userDetails });
                        //moment.tz.setDefault(userDetails.settings.timezone);
                        resolve(data);
                        // this.updateMyDetails().then((userData) => {
                        //     data.user = userData;
                        //     resolve(data);
                        // });
                    })
                })
                .catch((err) => {
                    try {
                        //reject(err.response.data.error);
                        reject("Invalid MFA token");
                    } catch (e2) {
                        reject((err || '').toString());
                    }
                });
        });
    }

    static async authenticate_old(email, password, mfaToken) {
        return new Promise((resolve, reject) => {
            Http.post('/api/users/authenticate', {
                email: unsafeEncrypt(email.trim()),
                password: unsafeEncrypt(password.trim()),
                mfaToken: unsafeEncrypt(mfaToken),
            })
                .then((response) => {
                    const data = response.data;
                    localStorage.setItem(LOCALSTORAGE_AUTH_KEY, JSON.stringify(data.auth));
                    userDetails = data.user;
                    publish('USER_DETAILS_UPDATED', { ...userDetails });
                    //moment.tz.setDefault(userDetails.settings.timezone);
                    resolve(data);
                    // this.updateMyDetails().then((userData) => {
                    //     data.user = userData;
                    //     resolve(data);
                    // });
                })
                .catch((err) => {
                    try {
                        reject(err.response.data.error);
                    } catch (e2) {
                        reject((err || '').toString());
                    }
                });
        });
    }

    static resetSession() {
        localStorage.removeItem(LOCALSTORAGE_AUTH_KEY);
        userDetails = null;
    }

    static async signout() {
        return new Promise((resolve, reject) => {
            Http.post('/logout')
                .then(() => {
                    this.resetSession();
                    publish('USER_DETAILS_UPDATED', null);
                    resolve();
                })
                .catch((err) => {
                    this.resetSession();
                    publish('USER_DETAILS_UPDATED', null);
                    resolve();
                });

            /*setTimeout(function () {
                resolve();
                //isAuthenticated = false;
            }, LOGON_DELAY);*/
        });
    }

    static async setNewDetails(user) {
        return new Promise((resolve, reject) => {
            Http.put('/users', user)
                .then((response) => {
                    this.updateMyDetails()
                        .then((res2) => {
                            resolve();
                        })
                        .catch((err) => {
                            reject(err);
                        });
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    static async updatePassword(oldPassword, newPassword) {
        const data = qs.stringify({
            newPassword: newPassword,
            oldPassword: oldPassword
        });
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };

        return Http.post('/auth/update-password', data, options);
    }

    static async forgotPassword(emailAddress) {
        const data = qs.stringify({
            emailAddress: emailAddress
        });
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };
        return Http.post('/auth/forgot-password', data, options);
    }

    static async forgotPasswordReset(newPassword, resetCode, emailAddress) {
        const data = qs.stringify({
            newPassword: newPassword,
            code: resetCode,
            emailAddress: emailAddress
        });
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };
        return Http.post('/auth/reset-password', data, options);
    }

    static async setupMFA(tempAuthToken, email, password) {
        return Http.post(
            '/api/users/mfa/setup-1',
            { email, password },
            {
                headers: {
                    tempToken: tempAuthToken,
                },
            }
        );
    }

    static async setupMFAVerify(token) {
        return Http.post('/api/users/mfa/setup-2-verify', {
            token,
        });
    }

    static async getSSODetails() {
        return new Promise((resolve, reject) => {
            Http.get('/auth/sso/details').then(response => {
                resolve(response.data);
            }).catch(err => reject(err))
        });
    }

    static async removeSSOAuthentication() {
        return Http.delete('/auth/sso/configure')
    }

    static async enableSSOAuthentication(data) {
        return new Promise((resolve, reject) => {
            Http.post('/auth/sso/configure', data)
                .then(response => {
                    resolve(response.data);
                })
                .catch(err => reject(err))
        });
    }

    // SSP login
    static ssoLogin(emailAddress) {
        redirectFormPost(`${Config.BASE_URL}/auth/sso/login`, {
            'emailAddress': emailAddress,
            'redirectTo': `${window.location.origin}/#/auth/sso-success`
        });
    }

    static async processSSOSuccess() {
        await Http.get('/auth/sso/login-success');
        window.location.href = '/'
    }

    static async requiresSSOLogin(emailAddress) {
        const data = qs.stringify({
            emailAddress: emailAddress
        });
        const options = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        };
        const resp = await Http.post('/auth/requires-sso-login', data, options)
        return resp.data['result'];
    }

    static async updateSettings(settings) {
        const response = await Http.put('/auth/me/update-settings', settings);
        moment.tz.setDefault(response.data.timezone);
        return response;
    }
}
